import linq from 'linq'
import { snakeToCamel, camelToSnake } from '../utility/stringUtility'
import User from './User'
import OrderItem from './OrderItem'
import CouponUser from './CouponUser'
import Form from 'vform'
import { arrayWrap } from '../utility/arrayUtitlity'
import OrderDeliveryAddress from './OrderDeliveryAddress'
import UserAddress from './UserAddress'
import Coupon from './Coupon'
import { dateFormat } from '../utility/dateUtility'
import OrderHistory from './OrderHistory'

const FILLABEL = [
    'id',
    'userId',
    'couponId',
    'name',
    'nameKana',
    'orderCompanyName',
    'usageDaysType',
    'usageDaysTypeName',
    'deliveryDate',
    'venueName',
    'phone',
    'endDate',
    'usageDate',
    'returnSchedule',
    'emergencyContact',
    'recipientName',
    'returnPersonName',
    'paymentName',
    'totalPriceJpy',
    'discountPriceJpy',
    'discountTotalPriceJpy',
    'transferName',
    'usageTime',
    'plannedNumber',
    'remarks',
    'useName',
    'usageDetail',
    'deliveryPersonName',
    'deliveryPersonTel',
    'deliveryTargetPhoneNumber',
    'deliveryTargetOther',
    'deliveryMethod',
    'deliveryDesiredTime',
    'deliveryDateNoon',
    'returnTargetOther',
    'returnMethod',
    'returnPersonTel',
    'returnDateNoon',
    'returnDate',
    'orderItems',
    'orderDeliveryAddress',
    'orderUserAddress',
    'createdAt',
]

const PRESENTS = [
    'deliveryPersonName',
    'deliveryPersonTel',
    'deliveryTargetPhoneNumber',
    'deliveryTargetOther',
    'deliveryMethod',
    'deliveryDateNoon',
    'orderCompanyName',
    'paymentName',
    'plannedNumber',
    'remarks',
    'returnPersonName',
    'returnPersonTel',
    'returnTargetOther',
    'returnMethod',
    'returnDateNoon',
    'usageDetail',
    'usageTime',
    'useName',
]

export const USE_NAME_WEDDING = 0
export const USE_NAME_SHOOTING = 1
export const USE_NAME_EVENT = 2
export const USE_NAME_PARTY = 3
export const USE_NAME_OTHER = 4
export const USE_NAME_LIST = [
    { name: '婚礼', value: USE_NAME_WEDDING },
    { name: '撮影', value: USE_NAME_SHOOTING },
    { name: 'イベント', value: USE_NAME_EVENT },
    { name: 'パーティー', value: USE_NAME_PARTY },
    { name: 'その他', value: USE_NAME_OTHER },
]

// 納品方法
export const DELIVERY_METHOD_TAKE_OUT = 0 // 受渡
export const DELIVERY_METHOD_DELIVER = 1 // 宅配
export const DELIVERY_METHOD_RECEIVING = 2 // 店舗受け取り
export const DELIVERY_METHOD_DELIVER_YAMATO = 3 // 宅配 ヤマト運輸
export const DELIVERY_METHOD_DELIVER_SAGAWA = 4 // 宅配 佐川急便
export const DELIVERY_METHOD_DELIVER_CHARTER = 5 // 宅配 チャーター便
export const DELIVERY_METHOD_RECEIVE_YOKOHAMA = 6 // 店舗受け取り 横浜

export const DELIVERY_METHOD_TYPE_LIST = [
    { name: '受渡', value: DELIVERY_METHOD_TAKE_OUT },
    { name: '宅配', value: DELIVERY_METHOD_DELIVER },
    { name: '店舗受け取り', value: DELIVERY_METHOD_RECEIVING },
]

/**
 * 時間指定
 */
export const TIME_TYPE_UNSPECIFIED = 0 // 指定なし
export const TIME_TYPE_MORNING = 1 // 午前中
export const TIME_TYPE_AFTERNOON = 2 // 午後
export const TIME_TYPE_SPECIFIED = 3 // 指定あり
export const TIME_TYPE_LIST = [
    { name: '指定なし', value: TIME_TYPE_UNSPECIFIED },
    { name: '午前中', value: TIME_TYPE_MORNING },
    { name: '午後', value: TIME_TYPE_AFTERNOON },
    { name: '指定あり', value: TIME_TYPE_SPECIFIED },
]

export default class Order {
    constructor(data = null) {
        this.originalData = data

        this.id = 0
        this.userId = 0
        this.couponId = 0
        this.name = ''
        this.nameKana = ''
        this.orderCompanyName = ''
        this.usageDate = ''
        this.usageDaysType = 0
        this.usageDaysTypeName = ''
        this.deliveryDate = ''
        this.deliveryAddress = ''
        this.venueName = ''
        this.phone = ''
        this.endDate = ''
        this.usageDay = ''
        this.emergencyContact = ''
        this.recipientName = ''
        this.paymentName = ''
        this.totalPriceJpy = 0
        this.discountPriceJpy = 0
        this.discountTotalPriceJpy = 0
        this.createdAt = ''
        this.updatedAt = ''
        this.isAccordion = false

        this.transferName = ''
        this.usageTime = ''
        this.plannedNumber = 0
        this.useName = null
        this.usageDetail = '' // ご利用用途詳細
        this.deliveryPersonName = '' // 納品担当者
        this.deliveryPersonTel = '' // 納品担当者連絡先
        this.deliveryTargetPhoneNumber = '' // 納品先電話番号
        this.deliveryTargetOther = '' // 納品 その他注意事項
        this.deliveryMethod = null // 納品方法
        this.deliveryDesiredTime = '' // 納品希望時間
        this.deliveryDateNoon = null // 納品時間指定

        this.returnDate = ''
        this.returnDateNoon = null
        this.returnPersonTel = ''
        this.returnPersonName = ''
        this.returnTargetOther = '' // 返却 その他注意事項
        this.returnMethod = null

        this.orderNumber = '' // 受注番号
        this.user = new User()
        this.couponUser = new CouponUser()
        this.coupon = new Coupon()
        this.orderDeliveryAddress = new OrderDeliveryAddress()
        this.orderUserAddress = new UserAddress()
        this.orderItems = []
        this.encryptCode = ''
        this.remarks = ''

        this.orderHistories = []
        this.latestOrderHistory = new OrderHistory()

        this.form = new Form()

        if (data) {
            this.create()
        }
    }

    get _model() {
        return 'Order'
    }

    create() {
        linq.from(this.data)
            .select((x) => {
                x.key = camelToSnake(x.key)
                return x
            })
            .where((x) => this.hasOwnProperty(snakeToCamel(x.key)))
            .select((x) => {
                const key = snakeToCamel(x.key)

                if (key === 'user') {
                    this[key] = new User(x.value)
                    return
                }

                if (key === 'couponUser') {
                    this[key] = new CouponUser(x.value)
                    return
                }

                if (key === 'coupon') {
                    this[key] = new Coupon(x.value)
                    return
                }

                if (key === 'orderItems') {
                    this[key] = linq
                        .from(x.value)
                        .select((x) => new OrderItem(x))
                        .toArray()
                    return
                }

                if (key === 'orderDeliveryAddress') {
                    this[key] = new OrderDeliveryAddress(x.value)
                    return
                }

                if (key === 'orderUserAddress') {
                    this[key] = new UserAddress(x.value)
                    return
                }

                if (key === 'latestOrderHistory') {
                    this[key] = new OrderHistory({ ...x.value })
                    return
                }

                if (key === 'orderHistories') {
                    this[key] = linq
                        .from(x.value)
                        .select((x) => new OrderHistory(x))
                        .toArray()
                    return
                }

                this[key] = x.value
                return x
            })
            .toArray()
    }

    get data() {
        return this.originalData
    }

    get hasError() {
        return Object.keys(this.form.errors.errors).length
    }

    get errors() {
        return linq
            .from(this.form.errors.errors)
            .select((x) => {
                return arrayWrap(x.value)[0]
            })
            .toArray()
    }

    joinWhere(x) {
        return linq.from(PRESENTS).any((xs) => x.key === xs)
    }

    getPostable() {
        return linq
            .from(this)
            .where((x) => linq.from(FILLABEL).any((xs) => xs === x.key))
            .where((x) => x.value || this.joinWhere(x))
            .select((x) => {
                return {
                    key: camelToSnake(x.key),
                    value: x.value,
                }
            })
            .toObject('$.key', '$.value')
    }

    fill() {
        this.form = new Form(this.getPostable())
    }

    async post(url) {
        this.fill()
        return await this.form.post(url)
    }

    async delete(url) {
        this.fill()
        return await this.form.delete(url)
    }

    async patch(url) {
        this.fill()
        return await this.form.patch(url)
    }

    // 利用用途によって変わるラベル取得
    get usageDetailLabel() {
        if (this.useName === USE_NAME_WEDDING) {
            return 'ご両家名'
        }
        if (this.useName === USE_NAME_OTHER) {
            return '詳細'
        }
        return ''
    }

    get inputReturnDate() {
        return this.returnDate
    }

    set inputReturnDate(val) {
        this.returnDate = dateFormat(val, 'YYYY-MM-DD')
    }

    get inputUsageDate() {
        return this.usageDate
    }

    set inputUsageDate(val) {
        this.usageDate = dateFormat(val, 'YYYY-MM-DD')
    }

    get inputDeliveryDate() {
        return this.deliveryDate
    }

    set inputDeliveryDate(val) {
        this.deliveryDate = dateFormat(val, 'YYYY-MM-DD')
    }

    changeUsageDetail() {
        if (this.useName !== USE_NAME_WEDDING && this.useName !== USE_NAME_OTHER) {
            this.usageDetail = ''
        }
    }

    get order() {
        if (this.latestOrderHistory.id) {
            return this.latestOrderHistory
        }
        return this
    }

    get fixTotalPrice() {
        return Number(this.discountTotalPriceJpy).toLocaleString()
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/models/Order.js